(function() {
  'use strict';

  let swiperInstance = null;

  function init() {
    initializeCarousel();
    initializeModal();
    injectNotificationStyles();
  }

  function initializeCarousel() {
    const swiperEl = document.querySelector('[data-swiper-carousel]');
    if (!swiperEl) return;

    if (typeof Swiper === 'undefined') {
      console.error('Swiper is not loaded');
      return;
    }

    swiperInstance = new Swiper(swiperEl, {
      slidesPerView: 'auto',
      spaceBetween: 10,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      breakpoints: {
        0: {
          slidesPerView: 1.5,
          spaceBetween: 16,
        },
        480: {
          slidesPerView: 'auto',
          spaceBetween: 16,
        },
      }
    });

    console.log('Swiper initialized for complementary products', swiperInstance);
  }

  function initializeModal() {
    const modal = document.getElementById('pairsWellModal');
    if (!modal) return;

    const modalOverlay = modal.querySelector('.complementary-products-modal__overlay');
    const modalClose = modal.querySelector('.complementary-products-modal__close');
    const modalContent = modal.querySelector('.complementary-products-modal__content');

    document.querySelectorAll('.complementary-products-card').forEach(card => {
      card.addEventListener('click', openModal);
    });

    if (modalClose) modalClose.addEventListener('click', closeModal);
    if (modalOverlay) modalOverlay.addEventListener('click', closeModal);
    if (modalContent) modalContent.addEventListener('click', (e) => e.stopPropagation());

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.classList.contains('active')) {
        closeModal();
      }
    });

    initializeForms();
  }

  function openModal() {
    const modal = document.getElementById('pairsWellModal');
    if (!modal) return;
    
    const header = document.querySelector('.shopify-section.header__outer-wrapper');
    modal.classList.add('active');
    document.body.style.overflow = 'hidden';
    
    header.style.setProperty('--z-index-header', '1');
    initializeAllVariants();
  }

  function closeModal() {
    const modal = document.getElementById('pairsWellModal');
    if (!modal) return;
    
    modal.classList.remove('active');
    document.body.style.overflow = '';
    const header = document.querySelector('.shopify-section.header__outer-wrapper');
   
    header.style.setProperty('--z-index-header', '500');
  }

  function initializeAllVariants() {
    document.querySelectorAll('.modal-product-item').forEach(item => {
      initializeProductVariants(item);
    });
  }

  function initializeProductVariants(productItem) {
    productItem.querySelectorAll('.variant-button').forEach(button => {
      button.addEventListener('click', handleVariantClick);
    });
    
    updateVariantDisplay(productItem);
    updateProductVariant(productItem);
  }

  function handleVariantClick(e) {
    const button = e.currentTarget;
    if (button.disabled) return;
    
    const productItem = button.closest('.modal-product-item');
    const variantGroup = button.closest('.variant-buttons');
    
    variantGroup.querySelectorAll('.variant-button').forEach(btn => {
      btn.classList.remove('active');
    });
    
    button.classList.add('active');
    updateVariantDisplay(productItem);
    updateProductVariant(productItem);
  }

  function updateVariantDisplay(productItem) {
    productItem.querySelectorAll('.variant-selector').forEach(selector => {
      const selectedSpan = selector.querySelector('.variant-selected');
      const activeButton = selector.querySelector('.variant-button.active');
      
      if (activeButton && selectedSpan) {
        selectedSpan.textContent = activeButton.dataset.value;
      }
    });
  }

  function updateProductVariant(productItem) {
    const productId = productItem.dataset.productId;
    const productData = window.pairsWellProducts?.[productId];
    
    if (!productData) return;
    
    const selectedOptions = getSelectedOptions(productItem);
    const matchingVariant = findMatchingVariant(productData.variants, selectedOptions);
    
    if (!matchingVariant) return;
    
    const variantIdInput = productItem.querySelector('input[data-variant-id]');
    if (variantIdInput) {
      variantIdInput.value = matchingVariant.id;
    }
    
    updateAddToCartButton(productItem, matchingVariant);
    updateVariantAvailability(productItem, productData.variants, selectedOptions);
  }

  function getSelectedOptions(productItem) {
    const options = [];
    productItem.querySelectorAll('.variant-selector').forEach(selector => {
      const activeButton = selector.querySelector('.variant-button.active');
      if (activeButton) {
        options.push(activeButton.dataset.value);
      }
    });
    return options;
  }

  function findMatchingVariant(variants, selectedOptions) {
    return variants.find(variant => {
      return variant.options.every((option, index) => {
        return option === selectedOptions[index];
      });
    });
  }

  function updateAddToCartButton(productItem, variant) {
    const button = productItem.querySelector('.modal-add-to-cart');
    if (!button) return;
    
    button.disabled = !variant.available;
    button.textContent = variant.available ? 'Add to Bag' : 'Sold out';
  }

  function updateVariantAvailability(productItem, allVariants, currentOptions) {
    productItem.querySelectorAll('.variant-selector').forEach((selector, optionIndex) => {
      selector.querySelectorAll('.variant-button').forEach(button => {
        const testOptions = [...currentOptions];
        testOptions[optionIndex] = button.dataset.value;
        
        const hasAvailableVariant = allVariants.some(variant => {
          return variant.options.every((opt, idx) => {
            if (idx === optionIndex) return opt === testOptions[idx];
            return opt === testOptions[idx] || testOptions[idx] === undefined;
          }) && variant.available;
        });
        
        button.disabled = !hasAvailableVariant;
      });
    });
  }

  function initializeForms() {
    document.querySelectorAll('[data-product-form]').forEach(form => {
      form.addEventListener('submit', handleAddToCart);
    });
  }
function handleAddToCart(e) {
  e.preventDefault();
  
  const form = e.currentTarget;
  const button = form.querySelector('.modal-add-to-cart');
  const formData = new FormData(form);
  const variantId = formData.get('id');
  const quantity = formData.get('quantity') || 1;
  
  if (!variantId) {
    showNotification('Please select all options', 'error');
    return;
  }
  
  button.classList.add('loading');
  button.disabled = true;
  
    if (typeof cart !== 'undefined' && typeof cart.addItem === 'function') {
    cart.addItem(form)
      .then(response => {
        const item = response.item;
        button.classList.remove('loading');
        button.disabled = false;
        
        if (typeof dispatchCustomEvent === 'function') {
          dispatchCustomEvent("cart:item-added", { product: item });
        }
        
        if (typeof showNotification === 'function') {
          showNotification('Product added to cart!', 'success');
        }
      })
      .catch(error => {
        if (typeof cart.get === 'function') {
          cart.get();
        }
        
        const quantityError = form.querySelector('[data-quantity-error]');
        if (quantityError) {
          if (error?.message) {
            quantityError.innerText = error.message;
          } else {
            const fallbackMsg = quantityError.getAttribute("data-fallback-error-message");
            quantityError.innerText = fallbackMsg || "An error occurred.";
          }
          quantityError.classList.remove("hidden");
        }
        
        if (typeof showNotification === 'function') {
          showNotification(error?.message || 'Error adding product to cart', 'error');
        }
        
        button.classList.remove('loading');
        button.disabled = false;
      });
  } else {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: parseInt(quantity)
      })
    })
    .then(response => {
      if (!response.ok) throw new Error('Error adding to cart');
      return response.json();
    })
    .then(data => {
      button.classList.remove('loading');
      button.disabled = false;
      
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
      
      if (typeof dispatchCustomEvent === 'function') {
        dispatchCustomEvent("cart:item-added", { product: data });
      }

      if (typeof updateCartCount === 'function') {
        updateCartCount();
      }
      
      if (typeof showNotification === 'function') {
        showNotification('Product added to cart!', 'success');
      }
    })
    .catch(error => {
      if (typeof showNotification === 'function') {
        showNotification('Error adding product to cart', 'error');
      }
      button.classList.remove('loading');
      button.disabled = false;
    });
  }
}
  function updateCartCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        document.querySelectorAll('[data-cart-count]').forEach(el => {
          el.textContent = cart.item_count;
        });
      });
  }

  function showNotification(message, type = 'success') {
    const notification = document.createElement('div');
    notification.textContent = message;
    notification.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background: ${type === 'error' ? '#dc2626' : '#16a34a'};
      color: white;
      padding: 16px 24px;
      border-radius: 8px;
      box-shadow: 0 4px 12px rgba(0,0,0,0.15);
      z-index: 10000;
      font-size: 14px;
      font-weight: 500;
      animation: slideInRight 0.3s ease;
    `;
    
    document.body.appendChild(notification);
    
    setTimeout(() => {
      notification.style.animation = 'slideOutRight 0.3s ease';
      setTimeout(() => notification.remove(), 300);
    }, 3000);
  }

  function injectNotificationStyles() {
    if (document.getElementById('complementary-products-notification-styles')) return;
    
    const style = document.createElement('style');
    style.id = 'complementary-products-notification-styles';
    style.textContent = `
      @keyframes slideInRight {
        from { transform: translateX(100%); opacity: 0; }
        to { transform: translateX(0); opacity: 1; }
      }
      @keyframes slideOutRight {
        from { transform: translateX(0); opacity: 1; }
        to { transform: translateX(100%); opacity: 0; }
      }
    `;
    document.head.appendChild(style);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();